import React from "react";
import { Link, Outlet } from "react-router-dom";
import "./communicate.css"
export default function CustomerCommun() {


    return (
        <div>
            <div className=" flex flex-row space-x-2 max-w-full min-w-fit landing-page">
                <Link to="farmers" className="hover:text-blue-500">Farmers</Link>
                <Link to="hotelOwners" className="hover:text-blue-500">hotelOwners</Link>
                <Link to="transOwners" className="hover:text-blue-500">transOwners</Link>
                <Link to="bankOwners" className="hover:text-blue-500">BankOwners</Link>
                <Link to="admins" className="hover:text-blue-500">Admins</Link>
            </div>
            <Outlet />
        </div>
    )
}